<template>
  <div v-if="dutyActivity.blockcode !== dutyActivity.shortName"
       class="d-flex flex-grow-0 align-center ml-auto"
       style="height: 30px">
    <div v-if="dutyActivity.shortName !== 'Fahren'"
         class="caption"
         style="font-size: 8px">
      {{ dutyActivity.shortName }}<v-icon :color="darkMode ? 'primary' : 'accent'"
              small>mdi-swap-horizontal</v-icon>
    </div>
    <v-icon v-else
            :color="darkMode ? 'primary' : 'accent'"
            small>mdi-bus</v-icon>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
export default {
  name: 'DutyActivityTypeIcon',
  mixins: [commonMixin],
  props: {
    dutyActivity: Object,
  },
};
</script>